import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

/** CardFlag is  */
const CardFlag = props => {
  const { className, children, ...other } = props;

  return (
    <div className={clsx("em-c-card__flag", className)} {...other}>
      {children}
    </div>
  );
};

CardFlag.propTypes = {
  /** Additional css classNames to append to the outer element */
  className: PropTypes.string,
  /** React component children */
  children: PropTypes.node
};

CardFlag.defaultProps = {
  className: "",
  children: null
};

export default CardFlag;
